export function isNil(v: any): v is null | undefined {
  if (v === null || v === undefined) {
    return true;
  }

  return false;
}
